<template>
    <div class="c-navbar">
        <router-link
            class="c-navbar-link c-navbar--practice-modes"
            :class="currentClass('/practice-modes')"
            to="/practice-modes"
            @click="$emit('navlinkClick')">
            <svg class="c-navbar-link__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_122_708)"><path d="m23.7 10.3-11-10-.3-.2h-.8l-.3.2-11 10a1 1 0 1 0 1.4 1.4l.3-.3V23q0 1 1 1h18q1 0 1-1V11.4l.3.3a1 1 0 0 0 1.4-1.4M10 22v-6a2 2 0 1 1 4 0v6zm10 0h-4v-6a4 4 0 1 0-8 0v6H4V9.6l8-7.2 8 7.2z" fill="#435166"/></g><defs><clipPath id="clip0_122_708"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></svg>
        </router-link>

        <router-link
            class="c-navbar-link c-navbar--profile"
            :class="currentClass('/profile')"
            to="/profile"
            @click="$emit('navlinkClick')">
            <svg class="c-navbar-link__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_122_713)" fill-rule="evenodd" clip-rule="evenodd" fill="#435166"><path d="M16.4 8.7a4.4 4.4 0 1 1-8.8 0 4.4 4.4 0 0 1 8.8 0m-2.2 0a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0"/><path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24M2.2 12q.1 3.5 2 6a9.8 9.8 0 0 1 15.6 0q2-2.6 2-6a9.8 9.8 0 1 0-19.6 0m9.8 9.8q-3.6 0-6.2-2.2a7.6 7.6 0 0 1 12.5 0 10 10 0 0 1-6.3 2.2"/></g><defs><clipPath id="clip0_122_713"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></svg>
        </router-link>

        <router-link
            class="c-navbar-link c-navbar--analytics"
            :class="currentClass('/analytics') || currentClass('/analytics/perfection') || currentClass('/analytics/practice') || currentClass('/analytics/correctness')"
            to="/analytics"
            @click="$emit('navlinkClick')">
            <svg class="c-navbar-link__icon" width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_122_717)" fill="#435166"><path d="M2.3 15H0v9h2.3zm4.9-6.3H4.9V24h2.3zM12 0H9.8v24H12zm5 8.7h-2.3V24h2.2zm4.8 6.3h-2.3v9h2.3z"/></g><defs><clipPath id="clip0_122_717"><path fill="#fff" d="M0 0h21.8v24H0z"/></clipPath></defs></svg>
        </router-link>

        <router-link
            class="c-navbar-link c-navbar--flow"
            :class="currentClass('/challenge/flow') || currentClass('/challenge') || currentClass('/challenge/select-user') || currentClass('/challenge/list') || currentClass('/challenge/requests')"
            to="/challenge/flow"
            @click="$emit('navlinkClick')">
            <svg class="c-navbar-link__icon" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.822 15.5l2.88 4.8m0 0l3.84 2.88m-3.84-2.88l-2.88 2.88m-1.92 0l1.92 1.92m5.76-3.84l16.32-16.32V1.1h-3.84L5.742 17.42" stroke="#435166" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M23.982 15.5l-2.88 4.8-3.84 2.88m8.64 0l-1.92 1.92zm-4.8-2.88l2.88 2.88zm-2.88.96L1.902 4.94V1.1h3.84l16.32 16.32" fill="#fff"/><path d="M23.982 15.5l-2.88 4.8m0 0l-3.84 2.88m3.84-2.88l2.88 2.88m1.92 0l-1.92 1.92m-5.76-3.84L1.902 4.94V1.1h3.84l16.32 16.32" stroke="#435166" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </router-link>

        <router-link
            class="c-navbar-link navbar-link__leaderboard c-navbar--leaderboard"
            :class="currentClass('/challenge/leaderboard')"
            to="/challenge/leaderboard"
            @click="$emit('navlinkClick')">
            <svg class="c-navbar-link__icon" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#prefix__clip0_139_1521)"><path d="M2.726 22.588H22.49M2.726 16.941H22.49l1.412-12.706-5.647 4.236-5.647-7.06-5.647 7.06-5.647-4.236 1.412 12.706z" stroke="#435166" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/></g><defs><clipPath id="prefix__clip0_139_1521"><path fill="#fff" d="M0 0h25v24H0z"/></clipPath></defs></svg>
        </router-link>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        methods: {
            currentClass(routepath){
                return this.$route.fullPath == routepath ? 'c-navbar--current' : '';
            }
        },
    };
</script>

<style scoped src="@/css/components/c-navbar.css"></style>